import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Label = ({ children, light = false }) => (
  <span
    className={`inline-flex items-center gap-3 text-[11px] font-sans font-medium uppercase tracking-[0.3em] ${
      light ? "text-[#0A0A0A]/70" : "text-[#2FBF8F]"
    }`}
  >
    <span className={`h-px w-8 ${light ? "bg-[#0A0A0A]/40" : "bg-[#2FBF8F]"}`} />
    {children}
  </span>
);
